<template>
  <div class="chapter-list-item">
    <div class="chapter-list-item__chapter-info clickable"
         v-bind:class="{ 'chapter-list-item__chapter-info--active': isActive }"
         v-on:click="selectChapter()">
      <div class="chapter-list-item__chapter-description">
        <div class="chapter-list-item__chapter-title typography--caption">
          {{ $t('series_cards.chapters.index', { i: chapter.position }) }}: {{ chapter.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'chapter-list-item',

    props: {
      chapter: {
        type: Object,
        default: null,
      },
      isActive: {
        type: Boolean,
        default: false,
      },
    },

    methods: {
      selectChapter() {
        if (this.isActive) {
          return;
        }

        this.$emit('select-chapter', this.chapter.id);
      },
    },
  };
</script>

<style lang="scss">
  .chapter-list-item {
    padding-top: 2px;
    padding-bottom: 2px;

    .chapter-list-item__chapter-info {
      position: relative;
      padding: 4px;
      height: 44px;
      border: 1px solid #e5e5e5;
      border-radius: 2px;
      transition: background-color .5s ease, border-color .5s ease;

      &:hover {
        background-color: #f7f7f7;
      }

      &:active {
        background-color: #eeeeee;
      }

      &.chapter-list-item__chapter-info--active {
        border-color: #00c896;
      }
    }

    .chapter-list-item__chapter-description {
      padding: 8px;
    }

    .chapter-list-item__chapter-title {
      line-height: 18px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1; /* number of lines to show */
      max-height: 18px;    /* fallback */
    }
  }
</style>



// WEBPACK FOOTER //
// src/app/publishers/components/ChapterListItem.vue